import { render } from "./CIS-Resource-PagedListing-Image.vue?vue&type=template&id=020d2e68&scoped=true"
import script from "./CIS-Resource-PagedListing-Image.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-Image.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-Image.vue?vue&type=style&index=0&id=020d2e68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020d2e68"]])

export default __exports__